<template>
  <div>
    <!-- 返回按钮 -->
    <header
      style="
        background-color: #3498db;
        color: white;
        padding: 10px;
        display: flex;
        align-items: center;
      "
    >
      <button
        @click="goBack"
        style="
          background: none;
          border: none;
          color: white;
          font-size: 16px;
          cursor: pointer;
        "
      >
        <a-icon type="arrow-left" /> 返回
      </button>
      <span style="flex: 1; text-align: center; font-size: 18px">{{
        aiItem.pTitle
      }}</span>
    </header>

    <!-- 嵌套 iframe -->
    <main style="height: calc(100vh - 50px); overflow: hidden">
      <iframe
        :src="aiItem.paramValue"
        style="width: 100%; height: 100%; border: none"
        title="嵌套页面"
      >
      </iframe>
    </main>
  </div>
</template>

<script>
import { getAIUrl } from "@/api/api";
export default {
  data() {
    return {
      aiItem: {},
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getAiUrl() {
      getAIUrl({
        paramKey: "AIURL",
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        this.aiItem = res;
      });
    },
  },
  mounted() {
    this.getAiUrl();
  },
};
</script>

<style scoped></style>
